import moment from 'moment';
import { getStore } from '@comall-backend-builder/core/lib/store';
import { language, uuid } from '@comall-backend-builder/core/lib/services';

import { BAN_ON_SOURCE } from './constants';

export const confirmProps = {
    title: '确定要删除吗？',
    okText: '确定',
    cancelText: '取消',
};

export const SCHEDULE_DELETE_EXTRA =
    '该记录来源于活动定时，删除后将从对应定时任务摘除该商品；若任务因此无商品将自动取消。';

export const isBanOnScheduleSource = (source?: string) =>
    source === BAN_ON_SOURCE.SCHEDULE || source === '活动定时';

export const getBanOnDeleteContent = (
    dim: 'SPU' | 'SKU',
    record: { code?: string; source?: string }
) => {
    const code = record.code || '';
    const base =
        dim === 'SPU'
            ? `确认删除 SPU【${code}】？删除后立即对该 SPU 下全部 SKU 重算规则。`
            : `确认删除 SKU【${code}】？删除后立即对该 SKU 重算规则。`;
    if (isBanOnScheduleSource(record.source)) {
        return `${base}${SCHEDULE_DELETE_EXTRA}`;
    }
    return base;
};

/** 模板上传需与 services.api 保持一致，否则跨域调 UAT 时易被 302 重定向到登录页 */
export const getTemplateUploadProps = () => {
    const user = getStore().getState().user;
    const headers: Record<string, string> = {
        'REQUEST-ID': uuid(),
        'Accept-Language': language.getCurrentLanguage().id,
    };
    if (user?.accessToken) {
        headers.Authorization = `Bearer ${user.accessToken}`;
    }
    return {
        headers,
        withCredentials: true,
    };
};

const pad = (num: number) => (num < 10 ? `0${num}` : `${num}`);

export const formatDateTime = (value?: string | number) => {
    if (value === undefined || value === null || value === '') {
        return '-';
    }
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
        return value;
    }
    const m = moment(value);
    return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : String(value);
};

export const formatNow = () => {
    const now = new Date();
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(
        now.getHours()
    )}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
};

export const getCreator = () => {
    try {
        const raw = window.localStorage.getItem('ssoSessionUser');
        if (raw) {
            const user = JSON.parse(raw);
            const id = user.id || user.userId || user.username || '';
            const name = user.name || user.username || '';
            if (id && name) {
                return `${id}-${name}`;
            }
            return name || id || '运营';
        }
    } catch (e) {
        // ignore
    }
    return '运营';
};
